import React from 'react';
import SEO from '@bradgarropy/gatsby-plugin-seo';
import { Link } from '@reach/router';
import useSiteMetadata from '../hooks/use-site-metadata';

import Layout from '../components/layout';

const PrivacyPolicy = () => {
  const { siteURL } = useSiteMetadata();
  return (
    <Layout>
      <SEO
        title='Privacy Policy | Praiser'
        description='Boost your team moral by praising them'
      />
      <div className='px-5 py-24 w-full max-w-2xl text-gray-700 mx-auto'>
        <div className='flex flex-col text-start mb-20 text-justify'>
          <h1 className='sm:text-4xl text-6xl font-bold title-font mb-16 text-gray-900'>
            Privacy Policy
          </h1>
          <p className='block mb-8 text-base'>
            Your privacy is important to us. It is Praiser's policy to respect
            your privacy regarding any information we may collect from you
            across our website,{' '}
            <Link className='text-indigo-600' to={siteURL}>
              {siteURL}
            </Link>
            , and other sites we own and operate.
          </p>
          <p className='block mb-8 text-base'>
            We only ask for personal information when we truly need it to
            provide a service to you. We collect it by fair and lawful means,
            with your knowledge and consent. We also let you know why we’re
            collecting it and how it will be used.
          </p>
          <p className='block mb-8 text-base'>
            We only retain collected information for as long as necessary to
            provide you with your requested service. What data we store, we’ll
            protect within commercially acceptable means to prevent loss and
            theft, as well as unauthorized access, disclosure, copying, use or
            modification.
          </p>
          <p className='block mb-8 text-base'>
            We don’t share any personally identifying information publicly or
            with third-parties, except when required to by law.
          </p>
          <p className='block mb-8 text-base'>
            Our website may link to external sites that are not operated by us.
            Please be aware that we have no control over the content and
            practices of these sites, and cannot accept responsibility or
            liability for their respective privacy policies.
          </p>
          <p className='block mb-8 text-base'>
            You are free to refuse our request for your personal information,
            with the understanding that we may be unable to provide you with
            some of your desired services.
          </p>
          <p className='block mb-8 text-base'>
            Your continued use of our website will be regarded as acceptance of
            our practices around privacy and personal information. If you have
            any questions about how we handle user data and personal
            information, feel free to contact us.
          </p>
          <p className='block mb-8 text-base italic'>
            This policy is effective as of 1st July 2020.
          </p>
        </div>
      </div>
    </Layout>
  );
};

export default PrivacyPolicy;
